import {ApiClient} from '@hconnect/apiclient'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {type ChecklistTemplateDto, ChecklistTemplateKind, HrocChecklistsQueryKey} from '../../types'

const STALE_TIME_IN_MS = 1000 * 60 * 15
const QueryKeyPreifx = HrocChecklistsQueryKey.ChecklistTemplates

type ChecklistTemplatesParams = {
  plantId: string
  templateKinds?: ChecklistTemplateKind[]
  templateTypes?: string[]
}

export const useChecklistTemplates = <TSelect = ChecklistTemplateDto[]>(
  {plantId, templateKinds, templateTypes}: ChecklistTemplatesParams,
  options?: Omit<
    UseQueryOptions<ChecklistTemplateDto[], AxiosError, TSelect>,
    'queryKey' | 'queryFn'
  >
) => {
  const path = `/hroc-checklists/api/${plantId}/checklist-templates`

  return useQuery<ChecklistTemplateDto[], AxiosError, TSelect>({
    queryKey: [QueryKeyPreifx, plantId, templateKinds, templateTypes],
    queryFn: async ({signal}) => {
      const response = await ApiClient.axiosInstance.get<ChecklistTemplateDto[]>(path, {
        params: {templateTypes},
        signal
      })

      return response.data
    },
    select: (data) => {
      if (!templateKinds || templateKinds.length === 0) {
        return data as TSelect
      }
      return data.filter((template) => templateKinds.includes(template.kind)) as TSelect
    },
    staleTime: STALE_TIME_IN_MS,
    ...options
  })
}
